export default __webpack_public_path__ + "static/driving-32471a112c28f83e6c9298caee0a1aa3.webp";